import { mutationFor, queryFor } from "@visioni/a3s-client-api/app";
import { listScenariosEndpoint, putScenarioEndpoint } from "../client-messages/scenarios";
import { listBucketsEndpoint } from "../client-messages/scenario-buckets";
import { getAssetLocationEndpoint } from "../client-messages/asset-location";

export const scenariosQuery = queryFor(listScenariosEndpoint);
export const bucketsQuery = queryFor(listBucketsEndpoint);
export const putScenarioMutation = mutationFor(putScenarioEndpoint);
export const assetLocationQuery = queryFor(getAssetLocationEndpoint);
